function calculateCentroid(points) {
    let totalX = 0;
    let totalY = 0;
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    points.forEach((point) => {
        totalX += point.x;
        totalY += point.y;
    });
    return { x: totalX / points.length, y: totalY / points.length };
}
function calculateAngle(point, centroid) {
    return Math.atan2(point.y - centroid.y, point.x - centroid.x);
}
function sortPointsByAngle(points, centroid) {
    return points.sort((a, b) => {
        return calculateAngle(a, centroid) - calculateAngle(b, centroid);
    });
}
function rotatePoints(points, centroid, startingAngle) {
    const firstPointIndex = points.findIndex((point) => calculateAngle(point, centroid) > startingAngle);
    if (firstPointIndex !== -1) {
        return [...points.slice(firstPointIndex), ...points.slice(0, firstPointIndex)];
    }
    return points;
}
export function angleOfFirstPoint(points) {
    if (!points[0]) {
        throw new Error();
    }
    const centroid = calculateCentroid(points);
    return calculateAngle(points[0], centroid);
}
export function alignShapeWinding(points, startingAngle) {
    const centroid = calculateCentroid(points);
    return rotatePoints(sortPointsByAngle(points, centroid), centroid, startingAngle);
}
//# sourceMappingURL=alignShapeWinding.js.map